import React from "react";
import classnames from "classnames";
import { financeNumberFormat } from "../../../../utils/formatters";
import VehicleImage from "../../../VehicleImage/VehicleImage";
import styles from "./style.module.css";

export default React.memo(({ className, vehicle }) => {
  return (
    <div className={classnames(styles.container, className)}>
      <div className={styles.info}>
        <h5 className={styles.title}>{vehicle?.vehicleTypeLabel}</h5>
        <span className={styles.fare}>{`$${financeNumberFormat(vehicle.fare?.baseRate || 0)}`}</span>
      </div>
      <VehicleImage vehicleType={vehicle?.vehicleType} className={styles.vehicleLogo} />
      <span className={styles.fareInfo}>
          Fare does not include, tips, tolls, stops, waiting time or state congestion tax, when applicable
      </span>
    </div>
  );
});
